module.exports = __webpack_public_path__ + "static/media/test_100_10.667fa459.png";